import { KEYWORD_RULES } from "./categories";

const NOISE = /\b(pos|debit|credit|card|purchase|recurring|ach|ppd|web|id|ccd|online|payment to|pmt|withdrawal|deposit|checkcard|visa|dda|tst\*|sq \*|sq\*|paypal \*|des:|indn:|co id:|ref)\b/gi;

export function merchantKey(desc = "") {
  const cleaned = desc
    .toLowerCase()
    .replace(/[0-9#*:/\\.,\-_]+/g, " ")
    .replace(NOISE, " ")
    .replace(/\s+/g, " ")
    .trim();
  return cleaned.split(" ").filter((w) => w.length > 1).slice(0, 3).join(" ") || desc.toLowerCase().trim();
}

export function merchantName(desc = "") {
  const key = merchantKey(desc);
  return key.replace(/\b\w/g, (c) => c.toUpperCase());
}

// Returns { category, auto, confident }
export function categorize(tx, rules = [], categories = []) {
  const key = merchantKey(tx.description);
  const valid = new Set(categories.map((c) => c.id));
  const learned = rules.find((r) => r.key === key && (!valid.size || valid.has(r.category)));
  if (learned) return { category: learned.category, confident: true, source: "learned" };
  const desc = tx.description || "";
  for (const [cat, re] of KEYWORD_RULES) {
    if (valid.size && !valid.has(cat)) continue;
    if (re.test(desc)) {
      const c = categories.find((x) => x.id === cat);
      // Income categories only for inflows; expense categories only for outflows
      if (c && c.type === "income" && tx.amount < 0) continue;
      if (c && (c.type === "expense" || c.type === "savings") && tx.amount > 0 && cat !== "bank-fees") {
        // a positive amount on an expense category is a refund — keep the category
        return { category: cat, confident: /refund|return|reversal|credit/i.test(desc), source: "keyword" };
      }
      return { category: cat, confident: true, source: "keyword" };
    }
  }
  return tx.amount > 0
    ? { category: "other-income", confident: false, source: "default" }
    : { category: "unclassified-transactions", confident: false, source: "default" };
}

export function learnRule(rules, description, category) {
  const key = merchantKey(description);
  const rest = rules.filter((r) => r.key !== key);
  return [...rest, { key, category, createdAt: new Date().toISOString() }];
}
